/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';

import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import ContainersApi from '../../../../services/api/ContainersApi';
import FormRow from '../../../../components/common/forms/Row/FormRow';
import TextInputComponent from '../../../../components/common/forms/TextInput/TextInputComponent';
import validationSchema from '../validationSchema';
import PrimaryButton from '../../../../components/common/forms/Button/PrimaryButton';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import FormWrapper from '~/src/components/common/forms/FormWrapper/FormWrapper';
import BorderlessButton from '~/src/components/common/forms/Button/BorderlessButton';
import styled from 'styled-components';

export default function ContainerEdit() {
  const { id } = useParams();
  const [itemData, setItemData] = useState({
    name: '',
    width: '',
    length: '',
    height: '',
    doorWidth: '',
    doorHeight: '',
    usableHeight: '',
    maximumPayload: '',
    averageTare: '',
    cubicCapacity: '',
    pallets120X100: '',
    pallets120X80: '',
    palletsIso: '',
    pallets80X60: '',
    pallets120X20: '',
    dataArrived: false,
  });
  const history = useHistory();

  const saveItem = async (values, setSubmitting) => {
    setSubmitting(true);
    let result = null;
    if (id) {
      result = await ContainersApi.update(id, values);
    } else {
      result = await ContainersApi.create(values);
    }
    if (result.status === StatusCodes.OK) {
      history.push('/containers');
    } else {
      setSubmitting(false);
    }
  };

  const getItem = async () => {
    const result = await ContainersApi.get(id);
    const newItemData = { ...result.data, dataArrived: true };
    setItemData(newItemData);
  };

  useEffect(() => {
    if (id) {
      getItem(id);
    }
  }, []);

  return (
    <>
      <WhitePad>
        <TitleComponent
          onLeftHandler={() => {
            history.goBack();
          }}
          title={`${id ? 'Edit ' : 'Create '}Container`}
        />
        {id && itemData.dataArrived === false ? null : (
          <Formik
            initialValues={{
              name: itemData.name,
              width: itemData.width,
              length: itemData.length,
              height: itemData.height,
              doorWidth: itemData.doorWidth,
              doorHeight: itemData.doorHeight,
              usableHeight: itemData.usableHeight,
              maximumPayload: itemData.maximumPayload,
              averageTare: itemData.averageTare,
              pallets120X100: itemData.pallets120X100,
              pallets120X80: itemData.pallets120X80,
              palletsIso: itemData.palletsIso,
              pallets80X60: itemData.pallets80X60,
              pallets120X20: itemData.pallets120X20,
              cubicCapacity: itemData.cubicCapacity,
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              return saveItem(values, setSubmitting);
            }}
          >
            {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
              <FormWrapper width={'100%'}>
                <form onSubmit={handleSubmit} autoComplete="off">
                  <FormRow>
                    <TextInputComponent
                      name="name"
                      label="Name"
                      value={values.name}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={12}
                    />
                  </FormRow>
                  <FormRow>
                    <TextInputComponent
                      name="width"
                      label="Width (cm)"
                      value={values.width}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={4}
                      type="number"
                    />
                    <TextInputComponent
                      name="length"
                      label="Length (cm)"
                      value={values.length}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={4}
                      type="number"
                    />
                    <TextInputComponent
                      name="height"
                      label="Height (cm)"
                      value={values.height}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={4}
                      type="number"
                    />
                  </FormRow>
                  <FormRow>
                    <TextInputComponent
                      name="doorWidth"
                      label="Door Width (cm)"
                      value={values.doorWidth}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={4}
                      type="number"
                    />
                    <TextInputComponent
                      name="doorHeight"
                      label="Door Height (cm)"
                      value={values.doorHeight}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={4}
                      type="number"
                    />
                    <TextInputComponent
                      name="usableHeight"
                      label="Usable Height (cm)"
                      value={values.usableHeight}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={4}
                      type="number"
                    />
                  </FormRow>
                  <FormRow>
                    <TextInputComponent
                      name="maximumPayload"
                      label="Maximum Payload (kg)"
                      value={values.maximumPayload}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={4}
                      type="number"
                    />
                    <TextInputComponent
                      name="averageTare"
                      label="averageTare"
                      value={values.averageTare}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={4}
                      type="number"
                    />
                    <TextInputComponent
                      name="cubicCapacity"
                      label="cubicCapacity"
                      value={values.cubicCapacity}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={4}
                      type="number"
                    />
                  </FormRow>
                  <FormRow>
                    <TextInputComponent
                      name="pallets120x100"
                      label="pallets120x100"
                      value={values.pallets120X100}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={4}
                      type="number"
                    />
                    <TextInputComponent
                      name="pallets120x80"
                      label="pallets120x80"
                      value={values.pallets120X80}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={4}
                      type="number"
                    />
                    <TextInputComponent
                      name="palletsISO"
                      label="palletsISO"
                      value={values.palletsIso}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={4}
                      type="number"
                    />
                  </FormRow>
                  <FormRow>
                    <TextInputComponent
                      name="pallets80x60"
                      label="pallets80x60"
                      value={values.pallets80X60}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={4}
                      type="number"
                    />
                    <TextInputComponent
                      name="pallets120x20"
                      label="pallets120x20"
                      value={values.pallets120X20}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={4}
                      type="number"
                    />
                  </FormRow>
                  <ActionWrapper>
                    <PrimaryButton isSubmitting={isSubmitting} type="submit" title="Save" />
                    {/* <BorderlessButton
                      marginLeft="30px"
                      size="sm"
                      type="submit"
                      onClick={onDelete}
                      title="Delete"
                    /> */}
                  </ActionWrapper>
                </form>
              </FormWrapper>
            )}
          </Formik>
        )}
      </WhitePad>
    </>
  );
}

const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
`;
